import { analyticsPath } from './analytics-core.mjs';
import { shareTargets } from './share-delivery.mjs';

const campaignValues = {
  utm_source: ['musicmint_web','musicmint_ios','musicmint_android','google','bing','facebook','instagram','tiktok','x','newsletter'],
  utm_medium: ['share','social','email','organic','cpc','referral'],
  utm_campaign: ['song_share','gift_song'],
  utm_content: shareTargets,
};
export function analyticsLanding(href, referrer, origin) {
  const url = new URL(href, origin), query = new URLSearchParams();
  for (const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']) {
    const value = url.searchParams.get(key);
    if (!value || !/^[a-zA-Z0-9_-]{1,64}$/.test(value)) continue;
    // No arbitrary search terms, names or access tokens in campaign fields.
    if (key === 'utm_term' ? !['ai_music','song','gift','music_generator'].includes(value) : !campaignValues[key].includes(value)) continue;
    query.set(key, value);
  }
  let page_referrer = '';
  try {
    const from = new URL(referrer);
    if (['http:', 'https:'].includes(from.protocol) && !from.username && !from.password && from.origin !== origin) page_referrer = from.origin;
  } catch { /* Direct or invalid referrer. */ }
  return { page_location: origin + analyticsPath(url.pathname) + (query.size ? `?${query}` : ''), page_referrer };
}
